export const API_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:4000/api"
    : process.env.REACT_APP_API_URL!;

export const SOCKET_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:4000"
    : process.env.REACT_APP_SOCKET_URL!;
